import { Injectable } from '@angular/core';
import { ReportEntryControllerService, ReportEntryDto } from '@osos/shared/api';
import {
  IndexableLocalizedItem,
  LocalizedValueModel,
  ReportFormatEnum,
  Where,
} from '@osos/shared/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiUtilsService } from '../../api-utils/api-utils.service';

@Injectable()
export class ReportDataService extends ReportEntryControllerService {
  constructor(private apiHelper: ApiUtilsService) {
    super();
  }
  exportDataReport(params: {
    id: string;
    format: string;
    selectedColumns?: string[];
  }): Observable<Blob> {
    return params.format === ReportFormatEnum.PDF
      ? this.exportReportV2$Pdf(params)
      : this.exportReportV2$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet(
          params,
        );
  }

  public getReportsWithIdenticalNames(
    name: LocalizedValueModel,
    entityId: string,
    id?: string,
  ): Observable<IndexableLocalizedItem[]> {
    const localizedNameFilter: Where<ReportEntryDto> =
      this.apiHelper.prepareLocalPropFilter({
        name,
        id,
        propFilter: 'value.name',
      });
    const filter = {
      ...localizedNameFilter,
      'value.relatedTo.dataEntry': entityId,
    } as unknown as Where<ReportEntryDto>;
    return this.find(
      this.apiHelper.prepareFilter({
        where: filter,
        fields: { id: true, value: true },
      }),
    ).pipe(
      map((reports) =>
        reports.map((report) => {
          return {
            id: report.id,
            name: report.value.name,
          };
        }),
      ),
    );
  }
}
